import React, { useState, useEffect } from "react";
import "./createmsr.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notify } from '../../services/notification';
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { MsrAction } from "../../actions/msrAction";
import { PHONE_NUMBER_REGEX } from "../../constants/regex/regex";
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";


function CreateMsr() {
    const [loading, setLoading] = useState(false);
    const MobileCode = "91";
    const { isSidebarOpen, toggleSidebar } = useMobileView();


    const [states, setStates] = useState({
        name: "",
        msr_id: "",
        mobile_number: "",
        address: "",
        mobile_code: MobileCode,
    });





    const handleInput = (evt) => {
        const value = evt.target.value;
        setStates({
            ...states,
            [evt.target.name]: value.replace(/^ +/gm, ""),
        });
    };

    const handleOnSaveClick = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await dispatch(MsrAction(states));
            if (response?.status === 200 || response?.status === 201) {
                notify.success(response?.data?.message);
                setLoading(false);
                navigate("/msr");
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const validatePhoneNumber = (value) => {
        if (value === "" || PHONE_NUMBER_REGEX.test(value)) {
            setStates((prevState) => ({
                ...prevState,
                mobile_number: value.replace(/^ +/gm, ""),
            }));
        }
    };

    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (
        <div className="create-msr-container" style={{ marginTop: "10 rem" }}>
            <div className="create-msr-containerright">
                <Header title="Create MSR" />
                <>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className="form-div" style={{ marginLeft: "10 rem" }}  >
                            <div className="grid">
                                <label className="label-create-msr">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter Full Name"
                                    value={states.name}
                                    onChange={handleInput}
                                    className="create-msr-input-field"
                                    required
                                />
                            </div>
                            <div className="grid">
                                <label className="label-create-msr">MSR Id</label>
                                <input
                                    type="text"
                                    name="msr_id"
                                    placeholder="MSR Id"
                                    value={states.msr_id}
                                    onChange={handleInput}
                                    required
                                    className="create-msr-input-field"
                                />
                            </div>
                            <div className="grid">
                                <label className="label-create-msr">Phone Number</label>
                                <div>
                                    <input
                                        type="text"
                                        name="mobile_number"
                                        placeholder="Enter Phone Number"
                                        value={states.mobile_number}
                                        minLength={10}
                                        maxLength={10}
                                        onChange={(e) => validatePhoneNumber(e.target.value)}
                                        className="create-msr-input-field"
                                    />
                                    {states.mobile_number && states.mobile_number.length !== 10 && (
                                        <span className="error-message">
                                            Phone number must be exactly 10 digits.
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="grid">
                                <label className="label-create-msr">Address</label>
                                <textarea
                                    type="text"
                                    name="address"
                                    value={states.address}
                                    onChange={handleInput}
                                    placeholder="Enter Address"
                                    className="create-msr-input-field"
                                />
                            </div>

                            <div className="btn-notify">
                                <button
                                    onClick={() => navigate("/msr")}
                                    className="msr-active"
                                >
                                    Close
                                </button>
                                <button
                                    className="msr-active"
                                    type="submit"
                                    disabled={!states.name || !states.msr_id || !states.mobile_number}
                                    onClick={handleOnSaveClick}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    )}
                </>
            </div>
        </div>
    );
}

export default CreateMsr;